import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomSize = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { roomSize } = viewModel;

	const onSetRoomSize = useCallback(
		(input: number | undefined) => {
			onSetViewModel([{ key: "roomSize", value: { isEdited: true, value: input! } }]);
		},
		[onSetViewModel],
	);

	const isEdited = roomSize?.isEdited;
	const hasError = Boolean(roomSize?.error);

	return {
		isEdited,
		hasError,

		roomSize,
		onSetRoomSize,
	};
};
